import { Switch } from '@mui/material';
import React, { Component } from 'react'

export class LabeledSwitch extends Component {
    render() {
        const { value, onChange, label } = this.props;
        return (
            <div style={{ display: 'flex', flexDirection: "row" }}>
                <Switch
                    checked={value}
                    onChange={onChange}
                    color="primary"
                />
                <span
                    style={{
                        alignSelf: "center",
                        userSelect: "none",
                        WebkitUserSelect: "none",
                        MozUserSelect: "none",
                        msUserSelect: "none"
                    }}
                >
                    {label}
                </span>
            </div>
        )
    }
}

export default LabeledSwitch